






















import { defineComponent } from '@vue/composition-api'
import ConversationNav from './ConversationNav.vue'

export default defineComponent({
  props: {
    conversationId: {
      type: String
    }
  },

  components: {
    ConversationNav
  }
})
